<div class="card {{ type }}">
  <h5 class="card-header" [innerHTML]="title"></h5>
  <div class="card-subtitle" *ngIf="subtitle" [innerHTML]="subtitle"></div>
  <div class="card-body">
    <ng-content></ng-content>
  </div>
  <div class="card-footer">
    <ng-content select="[wsb-ui-card-footer]"></ng-content>
  </div>
</div>
